if (!customElements.get('flavor-selector')) {
  class FlavorSelector extends HTMLElement {
    connectedCallback() {
      this.disclosure = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      if (!this.disclosure || !this.trigger || this.controller) return;

      this.controller = new AbortController();
      this.pointerStartedInside = false;
      const options = { signal: this.controller.signal };
      this.addEventListener('keydown', (event) => this.onKeydown(event), options);
      this.addEventListener('focusout', (event) => {
        if (this.pointerStartedInside) return;
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
      }, options);
      document.addEventListener('pointerdown', (event) => {
        this.pointerStartedInside = this.contains(event.target);
        if (!this.pointerStartedInside) this.close();
      }, options);
      document.addEventListener('click', () => {
        this.pointerStartedInside = false;
      }, { ...options, capture: true });
      document.addEventListener('pointercancel', () => {
        this.pointerStartedInside = false;
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const row = Array.from(this.querySelectorAll('[data-flavor-block]'))
          .find((item) => item.dataset.flavorBlock === event.detail?.blockId);
        if (!row) return;
        this.disclosure.open = true;
        row.scrollIntoView({ block: 'nearest' });
      }, options);
      document.addEventListener('shopify:block:deselect', (event) => {
        if (this.contains(event.target)) this.close();
      }, options);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.pointerStartedInside = false;
    }

    close(restoreFocus = false) {
      if (!this.disclosure.open) return;
      this.disclosure.open = false;
      if (restoreFocus) this.trigger.focus();
    }

    onKeydown(event) {
      this.pointerStartedInside = false;
      if (event.key === 'Escape' && this.disclosure.open) {
        event.preventDefault();
        event.stopPropagation();
        this.close(true);
        return;
      }

      const links = Array.from(this.querySelectorAll('.pdp-flavors__link'));
      if (!links.length) return;
      const index = links.indexOf(document.activeElement);
      const onTrigger = document.activeElement === this.trigger;
      let nextIndex;

      if (event.key === 'ArrowDown') nextIndex = onTrigger ? 0 : (index + 1) % links.length;
      else if (event.key === 'ArrowUp') nextIndex = onTrigger ? links.length - 1 : (index - 1 + links.length) % links.length;
      else if (event.key === 'Home' && index !== -1) nextIndex = 0;
      else if (event.key === 'End' && index !== -1) nextIndex = links.length - 1;
      else return;

      if (!onTrigger && index === -1) return;
      event.preventDefault();
      this.disclosure.open = true;
      links[nextIndex].focus();
    }
  }

  customElements.define('flavor-selector', FlavorSelector);
}
